import { Card, Alert, Tabs, Tab, Box } from "@mui/material"; 
import React, { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import GeneralData from "./generalData/generalData";
import TreatmentsList from "./treatments/treatmentList.js";
import GeneralEvolutionList from "./generalEvolution/generalEvolutionList.js";
import AnamnesisForm from "./anamnesis/anamnesisForm.js";
import PrescriptionListRouter from "./prescriptions/prescriptionList/prescriptionListRouter.js";
import AttestedList from "./attested/attestedList.js";
import TermsTabList from "./terms/termsTabList.js";
import ImageList from "../form/image/imageList.js";


const TAB_CONFIGS = [
    { label: "Dados Gerais", component: GeneralData},
    { label: "Anamnese", component: AnamnesisForm},
    { label: "Tratamentos", component: TreatmentsList},
    { label: "Receituário", component: PrescriptionListRouter},
    { label: "Atestados", component: AttestedList},
    { label: "Evoluções", component: GeneralEvolutionList},
    { label: "Termos", component: TermsTabList},
    { label: "Imagens", component: ImageList}
];

export default function PatientForm() {
  const [searchParams] = useSearchParams();

  const hasTabParam = searchParams.get('tab');

  const getInitialTab = () => {
    if (hasTabParam === 'evolutions') {
      const evolutionIndex = TAB_CONFIGS.findIndex(tab => tab.label === "Evoluções");
      if (evolutionIndex !== -1) {
        return evolutionIndex; 
      }
    }
    return 0; 
  };
  const [currentTabIndex, setCurrentTabIndex] = useState(getInitialTab);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const isNewPatient = !selectedPatient || !selectedPatient.id;

  const saveNewPatient = useCallback((savedPatient) => {
    if (isNewPatient) {
      setSuccessMessage('Paciente salvo com sucesso!.');
      setShowSuccessMessage(true);
    }  
      setSelectedPatient(savedPatient);
    }, [isNewPatient]);

  const patientLoaded = useCallback((loadedPatient) => {
    setSelectedPatient(loadedPatient);
  }, []);

  const changeActiveTab = (event, newIndex) => {
    setCurrentTabIndex(newIndex);
  };


  return (
    <Box sx={{ p: 3 }}>
      {showSuccessMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}

      <Card>
        <Tabs value={currentTabIndex} onChange={changeActiveTab} variant="fullWidth">
          {TAB_CONFIGS.map((tab, index) => (
            <Tab label={tab.label} key={index} disabled={index > 0 && isNewPatient}/>  
          ))}      
        </Tabs>

        <Box sx={{ p: 3, pt: 5 }}>
          {TAB_CONFIGS.map((tab, index) => {
            const TabComponent = tab.component;
            return (
              <Box
                key={index}
                sx={{ display: currentTabIndex === index ? 'block' : 'none' }}
              >
                <TabComponent
                  patient={selectedPatient}
                  onSaveSuccess={saveNewPatient}
                  onPatientLoaded={patientLoaded}
                />
              </Box>
            );
          })}
        </Box>
      </Card>
    </Box>
  );
}